'use strict';

require('../sections/product');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _themeSections = require('@shopify/theme-sections');

var sections = _interopRequireWildcard(_themeSections);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(document).ready(function () {
  sections.load('product');
});